// O pilar `seguranca` representa hoje o critério de Risco (severidade do impacto
// de NÃO implementar a ação), sucessor do antigo critério "Segurança Jurídica".
// O nome do campo foi mantido por compatibilidade com os dados já gravados nas
// organizações (Firestore `organizacoes/{orgId}/priorizacoes/{questaoId}`).
export const IAP_WEIGHTS = {
    missao: 5,
    seguranca: 3,
    viabilidade: 2
};

export const calculateIAP = (m, s, v) => {
    const isValue = (val) => val !== null && val !== undefined && val !== '' && Number(val) !== 0;

    // Se nenhum dos três pilares foi preenchido, retornamos null (Não Definida)
    if (!isValue(m) && !isValue(s) && !isValue(v)) return null;

    // Se pelo menos um foi preenchido, tratamos os outros vazios como zero
    const valM = isValue(m) ? parseInt(m) : 0;
    const valS = isValue(s) ? parseInt(s) : 0;
    const valV = isValue(v) ? parseInt(v) : 0;

    // Fórmula: (Missão*5 + Risco*3 + Viabilidade*2) / 10
    return ((valM * IAP_WEIGHTS.missao) + (valS * IAP_WEIGHTS.seguranca) + (valV * IAP_WEIGHTS.viabilidade)) / 10;
};

export const getClassificacaoIAP = (iap) => {
    if (iap === null || iap === undefined) return 'Não Definida';
    
    // Se iap for 0 mas veio de algum pilar preenchido, cai na classificação normal
    if (iap >= 4.1) return 'Essencial';
    if (iap >= 3.1) return 'Estratégico';
    if (iap >= 2.1) return 'Conformidade';
    // iap >= 0 ou qualquer valor calculado que não seja null
    return 'Baixa Prioridade';
};
